import axios from "axios";
import {SERVER_URL} from "./utils";

export default {
    // called when the user attempts to log in
    login: ({username, password}) => {
        const request = new Request(SERVER_URL + '/api/v1/auth/login', {
            method: 'POST',
            credentials: 'include',
            headers: new Headers({'Content-Type': 'application/json'}),
            body: JSON.stringify({email: username, password}),
        });
        return fetch(request)
            .then(response => {
                console.log(response.status)
                if (response.status !== 200) {
                    throw new Error(response.statusText);
                }
            }).then(() => console.log("OK"))
            .catch(() => {
                throw new Error('Network error')
            });
    },
    // called when the user clicks on the logout button
    logout: () => {
        return logout();
    },
    // called when the API returns an error
    checkError: ({status}) => {
        if (status === 401 || status === 403) {
            return Promise.reject();
        }
        return Promise.resolve();
    },
    // called when the user navigates to a new location, to check for authentication
    checkAuth: () => {
        const request = new Request(SERVER_URL + '/api/v1/auth/refresh', {
            method: 'GET',
            credentials: 'include',
        });
        return fetch(request)
            .then(response => {
                console.log(response.status)
                if (response.status === 401 || response.status === 500) {
                    throw new Error(response.statusText);
                }
            }).then(() => console.log("OK"))
            .catch(() => {
                throw new Error('Network error')
            });
    },
    // called when the user navigates to a new location, to check for permissions / roles
    getPermissions: async () => {
        if (window.location.href.toLowerCase().includes("register")) {
            return 'GUEST';
        }
        if (window.location.href.toLowerCase().includes("service/forgot-password")) {
            return 'GUEST';
        }

        const res = await axios.get(SERVER_URL + '/api/v1/auth/role', {
            withCredentials: true
        }).catch(err => {
            if (err.status === 401) {
                console.log('Not logged in')
            }
        })
        if (!res) {
            window.location.replace("/#/login")
            return 'GUEST';
        }
        console.log(res.data.role)
        return res.data.role;
    },
    getIdentity: async () => {
        const res = await axios.get(SERVER_URL + '/api/v1/auth/get-identity', {
            withCredentials: true
        }).catch(err => {
            if (err.status === 401) {
                console.log('Not logged in')
                window.location.replace("/#/login")
            }
        })
        return res.data;
    }
};

const logout = () => {
    const request = new Request(SERVER_URL + '/api/v1/auth/logout', {
        credentials: 'include',
        method: 'GET',
    });
    return fetch(request)
        .then(response => {
            console.log(response.status)
            if (response.status !== 200) {
                throw new Error(response.statusText);
            }
        }).then(() => {
            console.log("logged out")
            window.location.replace("/#/login")
        })
        .catch(() => {
            throw new Error('Network error')
        });
}